import { paths } from "@/paths";
import LoadingUser from "@commons/Loading/LoadingUser";
import { useUser } from "@hooks/useUser";
import { Navigate } from "react-router-dom";

export interface GuestGuardProps {
  children: React.ReactNode;
}

export function GuestGuard({ children }: GuestGuardProps): React.JSX.Element {
  const { user, isCheckingUser } = useUser();

  if (isCheckingUser) {
    return <LoadingUser />;
  }

  if (user) {
    return <Navigate to={paths.home} replace />;
  }

  return <>{children}</>;
}
